import { throttle, debounce } from 'underscore'
import gsap from 'gsap'

import Breakpoints from './Breakpoints'

// TODO : Au hover sur des hints, rajouter l'icône d'éclair ! Much simpler qu'un des éléments qui bouge avec la totalité.
export default class Cursor {
    constructor() {
        // silence is golden.
    }

    setupVars() {
        window.requestAnimationFrame =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.msRequestAnimationFrame
        this.lastPosInner = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        }

        this.lastPosOuter = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        }

        this.mousePos = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        }

        this.linksHoverMouseOver = (e) => {
            if (e.target.classList.contains('cursor--hintable')) {
                this.cursor.classList.add('hinting')
            } else {
                this.cursor.classList.add('hovering')
            }
        }

        this.linksHoverMouseLeave = (e) => {
            if (e.target.classList.contains('cursor--hintable')) {
                this.cursor.classList.remove('hinting')
            } else {
                this.cursor.classList.remove('hovering')
            }
        }
    }

    init() {
        this.setupVars()
        this.initElements()
        this.initEvents()
        this.linksSetup()
    }

    initElements() {
        // Parent
        this.cursor = document.createElement('div')
        this.cursor.classList.add('cursor')

        // Outer
        this.cursorOuterContainer = document.createElement('div')
        this.cursorOuterContainer.classList.add('cursor__outer-container')

        this.cursorOuter = document.createElement('div')
        this.cursorOuter.classList.add('cursor__outer')
        this.cursorOuterContainer.appendChild(this.cursorOuter)

        this.cursor.appendChild(this.cursorOuterContainer)

        // Inner
        this.cursorInnerContainer = document.createElement('div')
        this.cursorInnerContainer.classList.add('cursor__inner-container')

        this.cursorInner = document.createElement('div')
        this.cursorInner.classList.add('cursor__inner')
        this.cursorInnerContainer.appendChild(this.cursorInner)

        this.cursor.appendChild(this.cursorInnerContainer)

        // Extra
        this.cursorExtra = document.createElement('div')
        this.cursorExtra.classList.add('cursor__extra')
        this.cursor.appendChild(this.cursorExtra)

        // Append
        document.body.insertBefore(this.cursor, document.body.firstChild)
    }

    initEvents() {
        if (window.innerWidth > Breakpoints.intermediateTablet) {
            this.enableEvents()
        }
        // Window resize

        window.addEventListener(
            'resize',
            debounce(() => {
                if (window.innerWidth < Breakpoints.intermediateTablet) {
                    if (document.body.classList.contains('cursor--active')) {
                        this.disableEvents()
                    }
                } else {
                    if (!document.body.classList.contains('cursor--active')) {
                        this.enableEvents()
                    }
                }
            }),
            500
        )
    }

    linksSetup() {
        this.currentLinks = document.querySelectorAll(
            'a, .cursor--hintable, .motionTime__items-list li, .motionTime__closeBtn'
        )

        this.currentLinks.forEach((link) => {
            link.addEventListener(
                'mouseenter',
                this.linksHoverMouseOver.bind(this)
            )
            link.addEventListener(
                'mouseleave',
                this.linksHoverMouseLeave.bind(this)
            )
        })
    }

    removeCurrentLinks() {
        this.currentLinks.forEach((link) => {
            link.removeEventListener(
                'mouseenter',
                this.linksHoverMouseOver.bind(this)
            )
            link.removeEventListener(
                'mouseleave',
                this.linksHoverMouseLeave.bind(this)
            )
        })
    }

    enableEvents() {
        this.mousemoveInstance = throttle((e) => {
            this.mousePos = {
                x: e.clientX,
                y: e.clientY,
            }
        }, 50)
        document.body.classList.add('cursor--active')
        document.addEventListener('mousemove', this.mousemoveInstance)
        this.mousemoveRAFInstance = window.requestAnimationFrame(
            this.mousemoveRAF.bind(this)
        )
    }

    disableEvents() {
        document.body.classList.remove('cursor--active')
        window.cancelAnimationFrame(this.mousemoveRAFInstance)
        document.removeEventListener('mousemove', this.mousemoveInstance)
    }

    // Request Animation Frame function
    mousemoveRAF() {
        this.lastPosInner = {
            x: this.lerp(this.lastPosInner.x, this.mousePos.x, 0.4),
            y: this.lerp(this.lastPosInner.y, this.mousePos.y, 0.4),
        }

        this.lastPosOuter = {
            x: this.lerp(this.lastPosOuter.x, this.mousePos.x, 0.05),
            y: this.lerp(this.lastPosOuter.y, this.mousePos.y, 0.05),
        }

        this.cursorInnerContainer.style.transform = `translate(${this.lastPosInner.x}px, ${this.lastPosInner.y}px)`
        this.cursorOuterContainer.style.transform = `translate(${this.lastPosOuter.x}px, ${this.lastPosOuter.y}px)`

        // next frame
        this.mousemoveRAFInstance = window.requestAnimationFrame(
            this.mousemoveRAF.bind(this)
        )
    }

    // Lerp animation function
    lerp(a, b, n) {
        return (1 - n) * a + n * b
    }
}
